<div class="map-min" (click)="swithGalleryMap()">
  <img src="{{thumbnailUrl}}" alt="Карта" />
</div>
<div [hidden]="!isShowed">
  <div id="basemap"></div>
</div>

